import { useState } from "react";
import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import IndirectUseSoldTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import indirectIcon from "../../../../../assets/design-revamp-company/category-icons/indirect-use-icon.svg";
const IndirectUseContents = ({ businessId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable] = useState(false);
  return (
    <div className="use-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("COMP_INDIRECT_TITLE")}
          isNormal={true}
          number={"17.1.2"}
          icon={indirectIcon}
        />
      </div>

      {showTable && <IndirectUseSoldTable businessId={businessId} />}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default IndirectUseContents;
